module.exports = __webpack_public_path__ + "static/media/3.8-fern.4d47cf46.mp4";